import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { usePreviousPregnanciesChartsDataContext } from './hooks/usePreviousPregnanciesChartsDataContext';

export const PreviousBirthTypes = () => {
    const { chartData } = usePreviousPregnanciesChartsDataContext();

    return (
        <Donut
            title={'Tipos de Pastos em Gestações Anteriores'}
            subtitles={chartData?.previousBirthTypes?.map((item) => item.description)}
            chartData={chartData?.previousBirthTypes || []}
            colors={defaultColors.slice(0, chartData?.previousBirthTypes?.length) || []}
            height={400}
        />
    );
};
